import React from 'react'
import styles from './SplitSide.module.scss'

interface SplitSideProps {
  children: React.ReactNode
  className?: never
}

export const SplitSide: React.FC<SplitSideProps> = ({ children }) => (
  <div className={styles.side}>{children}</div>
)
